import { z } from "zod";

export const uploadBusinessLicenseResponseSchema = z.object({
  businesslicenseName: z.string(),
});

export type UploadBusinessLicenseResponseType = z.infer<typeof uploadBusinessLicenseResponseSchema>;
